import { getColors } from '@utils/StylesHelper'

function getColor({ color, theme }) {
  const colors = getColors(theme, color)
  const { dark } = colors

  return {
    '&.Mui-focusVisible': {
      outline: `2px solid ${dark}`,
      outlineOffset: 2,
    },
  }
}

function getColorStyle({ color, theme }) {
  const colors = getColors(theme, color)
  const { light, lighter, main } = colors

  return {
    color: main,
    backgroundColor: lighter,
    borderColor: light,
    '& .MuiChip-deleteIcon': {
      color: main,
      '&:hover': {
        color: light,
      },
    },
  }
}

export default function Chip(theme) {
  const defaultLightChip = getColorStyle({ color: 'secondary', theme })
  const COLORS = ['primary', 'secondary', 'error', 'info', 'success', 'warning']
  return {
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius,
          fontWeight: 700,
          '&:active': {
            boxShadow: 'none',
          },
          '&.MuiChip-colorPrimary': getColor({ color: 'primary', theme }),
          '&.MuiChip-colorSecondary': getColor({ color: 'secondary', theme }),
          '&.MuiChip-colorError': getColor({ color: 'error', theme }),
          '&.MuiChip-colorInfo': getColor({ color: 'info', theme }),
          '&.MuiChip-colorSuccess': getColor({ color: 'success', theme }),
          '&.MuiChip-colorWarning': getColor({ color: 'warning', theme }),
          variants: [
            { props: { variant: 'light' }, style: defaultLightChip },
            ...COLORS.map((color) => ({
              props: { variant: 'light', color },
              style: getColorStyle({ color, theme }),
            })),
            { props: { variant: 'combined' }, style: { border: '1px solid', ...defaultLightChip } },
            ...COLORS.map((color) => ({
              props: { variant: 'combined', color },
              style: getColorStyle({ color, theme }),
            })),
          ],
        },
        avatar: {
          color: theme.palette.common.white,
        },
        sizeLarge: {
          fontSize: '1rem',
          height: 40,
        },
      },
    },
  }
}
